// components/QueryConditions.js
import React, { useState, useEffect } from "react";
import ConditionGroup from "./ConditionGroup";

export const operators = [
  "=",
  "!=",
  ">",
  ">=",
  "<",
  "<=",
  "LIKE",
  "NOT LIKE",
  "IN",
  "NOT IN",
  "IS NULL",
  "IS NOT NULL",
];

const QueryConditions = ({ availableFields = [], onConditionsChange }) => {
  const [limit, setLimit] = useState("");
  const [offset, setOffset] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [orderDirection, setOrderDirection] = useState("asc");
  // Grouped WHERE conditions (starts with a root group)
  const [whereGroup, setWhereGroup] = useState({
    type: "group",
    operator: "AND",
    conditions: [],
  });

  // WHERE conditions list
  const [conditions, setConditions] = useState([
    // Example:
    // { field: "", operator: "=", value: "" }
  ]);

  // Notify parent of condition changes
  useEffect(() => {
    onConditionsChange({
      limit,
      offset,
      orderBy,
      orderDirection,
      where: whereGroup,
    });
  }, [limit, offset, orderBy, orderDirection, whereGroup]);

  return (
    <div className="mb-4 border rounded p-3 bg-light">
      <h5 className="fw-bold mb-3">⚙️ Query Options</h5>

      {/* Limit and Offset */}
      <div className="row mb-3">
        <div className="col-md-3">
          <label className="form-label">Limit</label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={limit}
            onChange={(e) => setLimit(e.target.value)}
            placeholder="e.g. 10"
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Offset (Skip)</label>
          <input
            type="number"
            min="0"
            className="form-control"
            value={offset}
            onChange={(e) => setOffset(e.target.value)}
            placeholder="e.g. 0"
          />
        </div>
      </div>

      {/* Order By */}
      <div className="row mb-4">
        <div className="col-md-6">
          <label className="form-label">Order By</label>
          <select
            className="form-select"
            value={orderBy}
            onChange={(e) => setOrderBy(e.target.value)}
          >
            <option value="">-- No ordering --</option>
            {availableFields.map((field) => (
              <option key={field.code} value={field.code}>
                {field.label}
              </option>
            ))}
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label">Direction</label>
          <select
            className="form-select"
            value={orderDirection}
            onChange={(e) => setOrderDirection(e.target.value)}
          >
            <option value="asc">Ascending</option>
            <option value="desc">Descending</option>
          </select>
        </div>
      </div>

      {/* WHERE Conditions */}
      <h6 className="fw-bold mb-2">WHERE Conditions</h6>
      <ConditionGroup
        group={whereGroup}
        availableFields={availableFields}
        onUpdate={setWhereGroup}
      />
    </div>
  );
};

export default QueryConditions;
